import ECharts from '~/components/echarts'
import ReactController from '~/controllers/react_controller'

export default class ServiceDeskVolumeTrendChartController extends ReactController {
  static values = {
    accountIds: Array,
    guardianTiers: Array,
    reporterTypes: Array,
    reporterScope: String,
    issuePriorities: Array,
    issueTypes: Array,
    issueReporters: Array,
    issueAssignees: Array,
    url: String,
  }

  createComponent() {
    const params = {
      query: {
        account_ids: this.accountIdsValue,
        guardian_tiers: this.guardianTiersValue,
        reporter_types: this.reporterTypesValue,
        reporter_scope: this.reporterScopeValue,
        issue_priorities: this.issuePrioritiesValue,
        issue_types: this.issueTypesValue,
        issue_reporters: this.issueReportersValue,
        issue_assignees: this.issueAssigneesValue,
      },
    }

    return (
      <ECharts title={null} url={this.urlValue} params={params} showMaximizeButton={false} showExportButton={false} />
    )
  }
}
